import { z } from 'zod';
// Request and response schemas for the API layer
export const AssignAddressToPersonRequestDTOSchema = z.object({
    body: z.object({
        addressId: z.string().uuid(),
    }),
    params: z.object({
        companyId: z.string().uuid(),
        personId: z.string().uuid(),
    }),
});
//# sourceMappingURL=assign-address-to-person.dto.js.map